import { DialogActions, DialogContent } from '@material-ui/core';
import React from 'react';
import { DialogTitle } from '../common/Dialog';
import { CloseIconButton } from '../common/IconButton';
import { Typography } from '../common/Typography';

export interface InvalidSaveModalProps {
  onClose: () => void;
}

export const InvalidSaveModal: React.FC<InvalidSaveModalProps> = ({ onClose }) => (
  <>
    <DialogTitle>You need at least 2 panoramas</DialogTitle>
    <DialogContent>
      <Typography>To save the panorama gallery, you need to have at least 2 panoramas.</Typography>
    </DialogContent>
    <DialogActions>
      <CloseIconButton onClick={onClose} />
    </DialogActions>
  </>
);
